import React from 'react';
import { ToggleButton, ToggleButtonGroup, Tooltip } from '@mui/material';
import { tt } from '@i18n/tt';

import { useAppDispatch, useAppSelector } from 'store/hooks';
import { setThemeMode, ThemeModeSelector } from 'store/themeMode';
import { Mode } from 'constants/enums';
import { ReactComponent as LightModeIcon } from 'assets/lightMode.icon.svg';
import { ReactComponent as NightModeIcon } from 'assets/nightMode.icon.svg';
import useStyles from './styles';

const ThemeSwitch: React.FC = () => {
  const dispatch = useAppDispatch();
  const themeMode = useAppSelector(ThemeModeSelector);
  const classes = useStyles();

  const handleChange = (_event: React.MouseEvent<HTMLElement>, newMode: Mode | null) => {
    if (newMode !== null) {
      dispatch(setThemeMode(newMode));
    }
  };

  return (
    <div className={classes.themeSwitch}>
      <ToggleButtonGroup
        value={themeMode}
        exclusive
        onChange={handleChange}
      >
        <Tooltip title={tt('theme.light')}>
          <ToggleButton value={Mode.Light}>
            <LightModeIcon />
          </ToggleButton>
        </Tooltip>
        <Tooltip title={tt('theme.dark')}>
          <ToggleButton value={Mode.Dark}>
            <NightModeIcon />
          </ToggleButton>
        </Tooltip>
      </ToggleButtonGroup>
    </div>
  );
};

export default ThemeSwitch;
